// import React, { useEffect, useState } from "react";
// import { Link } from "react-router-dom";
// import axios from "axios";

// const BASE_URL = "https://ecom.cyberathon.com";
// const API_URL = BASE_URL + "/index.php/Api/list_products";

// function HomeProducts() {
//   const [products, setProducts] = useState([]);

//   useEffect(() => {
//     const fetchProducts = async () => {
//       const res = await axios.get(API_URL);
//       const allProducts = res.data.data || [];

//       // Filter ONLY cupping category + limit 4
//       const cupping = allProducts
//         .filter((p) => p.category?.toLowerCase() === "cupping")
//         .slice(0, 4);

//       setProducts(cupping);
//     };

//     fetchProducts();
//   }, []);

//   return (
//     <>
//       <div className="container-fluid px-lg-5 px-2 bgg-col backSection14 py-3 backcolor1">

//         {/* Heading Row */}
//         <div className="d-flex justify-content-between align-items-center mb-4">
//           <h3 className="mb-0">Cupping Therapy Essentials</h3>
          
//           <p className="text-dark mb-0">
//             <span className="d-flex justify-content-between align-items-center gap-1">
//               View All
//               <Link
//                 to="/ProductsPage"
//                 state={{ category: "cupping" }}
//                 className="text-decoration-none"
//               >
//                 <i className="bi bi-chevron-right viewAll"></i>
//               </Link>
//             </span>
//           </p>
//         </div>

//         {/* Dynamic Product Cards */}
//         <div className="row gapp">
//           {products.map((item, index) => (
//             <div key={index} className="col-6 col-sm-6 col-md-3 col-lg-3 mb-2">
//               <div className="card custom-card">
                
//                 <div className="position-relative">
//                   <img
//                     src={`${BASE_URL}/${item.product_image}`}
//                     className="card-img-top"
//                     alt="Product"
//                   />
//                   <span className="badge bg-success position-absolute bottom-0 start-0 rounded-0">
//                     {item.discount}% Off
//                   </span>
//                 </div>

//                 <div className="card-body text-start">
//                   <h6 className="card-title mb-1 fw-bold">{item.name}</h6>

//                   <small className="mb-1 d-block">
//                     Premium Quality Cupping Therapy Cup
//                   </small>

//                   <div className="d-flex align-items-center justify-content-start gap-2">
//                     <p className="card-text fw-bold text-success mb-0">
//                       ₹{item.current_price}
//                     </p>

//                     <small className="text-decoration-line-through text-muted">
//                       ₹{item.old_price}
//                     </small>
//                   </div>

//                   {/* Rating */}
//                   <div className="text-warning mb-1">
//                     {Array.from({ length: Math.floor(item.rating) }).map(
//                       (_, i) => (
//                         <i key={i} className="bi bi-star-fill"></i>
//                       )
//                     )}
//                     {item.rating % 1 !== 0 && (
//                       <i className="bi bi-star-half"></i>
//                     )}
//                   </div>

//                   {/* Add to Cart */}
//                   <Link
//                     to="/DetailsPage"
//                     state={{ product: item }}
//                     className="text-decoration-none mt-auto"
//                   >
//                     <div className="bg-col text-white fw-semibold py-2 rounded d-flex justify-content-center align-items-center">
//                       Add to Cart{" "}
//                       <span className="ms-2">
//                         <i className="bi bi-bag"></i>
//                       </span>
//                     </div>
//                   </Link>

//                 </div>
//               </div>
//             </div>
//           ))}
//         </div>

//       </div>
//     </>
//   );
// }

// export default HomeProducts;


import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import axios from "axios";

const BASE_URL = "https://ecom.cyberathon.com";

function HomeProducts() {
  const [products, setProducts] = useState([]);

  useEffect(() => {
    const fetchProducts = async () => {
      const response = await axios.get(
        `${BASE_URL}/index.php/Api/list_products`
      );
      setProducts(response.data.data || []);
    };

    fetchProducts();
  }, []);

  return (
    <div className="container-fluid px-lg-5 px-2 backSection14 py-3 backcolor1">

      <div className="d-flex justify-content-between align-items-center mb-4">
        <h3 className="mb-0">Cupping Therapy Essentials</h3>

        <p className="mb-0">
          <Link to="/ProductsPage" state={{ category: "cupping" }} className="text-decoration-none">
            View All <i className="bi bi-chevron-right"></i>
          </Link>
        </p>
      </div>
      

      <div className="row gapp">

        {products.slice(0, 4).map((item, index) => (
          <div className="col-6 col-sm-6 col-md-3 col-lg-3" key={index}>
            <div className="card custom-card">

              <div className="position-relative">
                <img
                  src={`${BASE_URL}/${item.product_image}`}
                  className="card-img-top"
                  alt={item.name}
                />
                <span className="badge bg-success position-absolute bottom-0 start-0 rounded-0">
                  {item.discount}% off
                </span>
              </div>

              <div className="card-body text-start">
                <h6 className="fw-bold">{item.name}</h6>
                <small className="d-block">{item.category}</small>

                <div className="d-flex align-items-center gap-2">
                  <p className="fw-bold text-success mb-0">₹{item.current_price}</p>
                  <small className="text-decoration-line-through text-muted">
                    ₹{item.old_price}
                  </small>
                </div>

                <div className="text-warning mb-1">
                  ⭐ {item.rating}/5
                </div>

                <Link to="/DetailsPage" className="text-decoration-none">
                  <div className="bg-col text-white fw-semibold py-2 rounded text-center">
                    Add to Cart <i className="bi bi-bag ms-2"></i>
                  </div>
                </Link>
              </div>

            </div>
          </div>
        ))}

      </div>

    </div>
  );
}

export default HomeProducts;
